import { DetailPageActionTypes } from './constants'
import { StringId } from '../components/localizer/stringId'
import { MessageTypes } from '@dvui'

type BannerPayload = {
  stringId?: StringId
  string?: string
  heading?: string
  type: MessageTypes
}
export interface ICreateBanner {
  type: typeof DetailPageActionTypes.CreateBanner
  payload: BannerPayload
}

export interface IClearBanner {
  type: typeof DetailPageActionTypes.ClearBanner
}

export const createBanner = (payload: BannerPayload): ICreateBanner => ({
  type: DetailPageActionTypes.CreateBanner,
  payload
})

export const clearBanner = () => ({
  type: DetailPageActionTypes.ClearBanner
})
